import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslationService } from './shared/Services/translation.service';
import { NavBarComponent } from './shared/Components/nav-bar/nav-bar.component';
import { FooterComponent } from './shared/Components/footer/footer.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavBarComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  language: any;

  constructor(
    private translationService: TranslationService,
    private router: Router
  ) {
    this.language = localStorage.getItem(translationService.langName);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: -100 });
      });
  }

  ngOnInit(): void {
    this.translationService.usePresentLang(this.language || 'EN');

    if (!this.language) {
      this.language = 'EN';
      localStorage.setItem(this.translationService.langName, 'EN');
    }

    this.getLanguage();
  }

  getLanguage() {
    this.translationService.language$.subscribe((lang) => {
      this.language = lang;
    });
  }
}
